export const hasPermission = (user, permissions) => permissions.every(permission => user?.permissions?.includes(permission));
